<template>
  <div id="htmlPageViewer">
    <!-- 1. 空状态展示：无数据时显示 -->
    <NOT_DATA
      className="relativePtb30"
      v-if="!isHasData"
    />

    <!-- 2. 有数据时展示 HTML 页面 (使用 v-else 即可，无需重复判断) -->
    <div v-else class="htmlPage_container">
      <!-- 使用 iframe 隔离展示外部 HTML -->
      <iframe
        ref="iframeRef"
        :src="htmlSrc"
        frameborder="0"
        class="htmlPage_iframe"
        @load="handleIframeLoad"
      ></iframe>
    </div>
  </div>
</template>

<script>
// 引入空状态组件
import NOT_DATA from '@components/base/NO_DATA.vue'
// 修复：移除多余的换行
import { https_cup_scheduleAIForwardLooking } from '@api/platfrom_football_api'
import cup_base_data_mixin from '@mixins/cup_base_data'

export default {
  name: 'HtmlPageViewer',
  components: { NOT_DATA },
  mixins: [cup_base_data_mixin],
  // 修复：htmlSrc 和 isHasData 改为内部 data，因为需要在组件内被修改
  props: {
    // 如果父组件有传初始路径的需求，可以保留一个初始 prop，比如 initialSrc
  },
  data() {
    return {
      htmlSrc: '',       // 内部维护 htmlSrc
      isHasData: false,  // 内部维护 isHasData
      isLoading: true
    }
  },
  created() {
    this.init()
  },
  methods: {
    // 初始化方法
    async init() {
      // 触发全局加载事件
      if (window.mixtmtBase_eventBus) {
        window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      }

      const query = this.$route.query
      console.log('HTML Viewer 初始化，路由参数:', query)

      // 请求接口获取数据
      await this.getScheduleAIForwardLooking(query)

      // 关闭全局加载事件
      if (window.mixtmtBase_eventBus) {
        window.mixtmtBase_eventBus.$emit('loadingEvent', false)
      }
    },
    // 访问接口获取 html 地址
    async getScheduleAIForwardLooking(query) {
      try {
        const response = await https_cup_scheduleAIForwardLooking(this.axiosBaseUrl, this.$axios, query)
        const res = response.data
        console.debug('res:', res)

        if (res.status === 0) {
          // 修复：根据实际接口返回结构调整，假设 res.data 就是目标字符串
          this.htmlSrc = res.data

          // 只要有 htmlSrc 就代表有数据
          if (this.htmlSrc) {
            this.isHasData = true
          }
        } else {
          // 接口返回非 0 状态，展示提示信息
          if (res.message) {
            this.$message({
              showClose: true,
              message: res.message,
              type: 'warning',
            })
          }
        }
      } catch (err) {
        console.debug('接口请求失败:', err)
      }
    },
    // iframe 加载完成的回调
    handleIframeLoad() {
      this.isLoading = false
      console.log('外部 HTML 页面加载完成')
    }
  }
}
</script>

<style lang="scss" scoped>
#htmlPageViewer {
  padding: 1.388vw 0;
  width: 100%;
  height: auto;

  .htmlPage_container {
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
    height: 125vh;
    padding: 1.388vw 1.11vw;
    background-color: #f5f5f5;
    box-sizing: border-box;

    .htmlPage_iframe {
      width: 100%;
      height: 100%;
      border: none;
      display: block;
      background-color: #fff;
    }
  }
}
</style>